import React from 'react';
import { VERIFIED_TICK_TITLE, attended_label, handoff_attended, kind_icon, needs_human_since, wait_band, wait_label } from './user_chat';
import FaIcon from '../../components/FaIcon';

/**
 * The small row pieces of a client conversation, shared by the Chat inbox and
 * the client page's Chats tab (CT-15539) so a private chat reads the same in
 * both: the 👤 / 👥 kind glyph, the verified tick, the "🙋 12m" wait badge.
 */

const WAIT_COLORS = { fresh: ['#2e7d4f', '#eefaf2', '#cfeedd'], warm: ['#b9770e', '#fff8e6', '#f0d48a'], hot: ['#c0392b', '#fff4f2', '#f3d3cd'] };

/** "🙋 12m" — how long a user chat has waited for a person. */
export function WaitBadge({ at, now }) {
    const band = wait_band(at, now);
    if (!band) return null;
    const [fg, bg, bd] = WAIT_COLORS[band];
    return (
        <span title={`Waiting for a person since ${needs_human_since(at)}`}
            style={{ fontSize: 10, color: fg, background: bg, border: '1px solid ' + bd, borderRadius: 9, padding: '1px 7px', whiteSpace: 'nowrap', fontWeight: 600 }}>
            <FaIcon name='hand-paper' label='needs a person' /> {wait_label(at, now)}
        </span>
    );
}

/** "✓ Attended by Madhurima" — a request for a person that a representative answered; the Chat inbox
 *  lists it under "Answered", below the waiting ones (Aesha 2026-09-24). */
export function AttendedMark({ c }) {
    const a = handoff_attended(c);
    if (!a) return null;
    const asked = c.handoff && c.handoff.askedAt ? needs_human_since(c.handoff.askedAt) : '';
    return (
        <span title={`Asked for a person ${asked ? 'at ' + asked : ''}; answered ${needs_human_since(a.at)}`.trim()} data-testid='attended-mark'
            style={{ fontSize: 10, color: '#5d6d7e', background: '#f4f6f8', border: '1px solid #dde3e8', borderRadius: 9, padding: '1px 7px', whiteSpace: 'nowrap' }}>
            <FaIcon name='check' /> {attended_label(c)}
        </span>
    );
}

/** Small green tick after a chat owner who linked their own WhatsApp number (verifiedVia 'self'). */
export function VerifiedTick({ size }) {
    return (
        <span role='img' aria-label='verified' title={VERIFIED_TICK_TITLE}
            style={{ display: 'inline-block', marginLeft: 4, color: '#2e7d4f', fontSize: size || 11, fontWeight: 700 }}><FaIcon name='check' /></span>
    );
}

/** 👤 before a person's private chat, 👥 before a WhatsApp / org group — the glance-level tell between the two kinds in one feed. */
export function KindIcon({ c, size }) {
    const icon = kind_icon(c);
    if (!icon) return null;
    return <span role='img' aria-label={icon.label} title={icon.label} style={{ fontSize: size || 12, marginRight: 5 }}><FaIcon name={icon.icon} /></span>;
}

export const KIND_CHIP = { fontSize: 9.5, color: '#6c4bb5', background: '#f3efff', border: '1px solid #ddd2f6', borderRadius: 8, padding: '0 6px', fontWeight: 600, letterSpacing: 0.3 };
